module.exports = __webpack_public_path__ + "static/media/countingwell-banner-1.e732de8c.png";